import { Banner, MarketSlider, StepByStep, BorderCount, PairTable, News, Cta1, HomepageImage, CollaborationSection, TokenCard } from '../components';
import BinanceTicker from '../components/BinanceTicker';
import { useTranslation } from 'react-i18next';

export default function Home() {
    const { t } = useTranslation();

    return (
        <div>
            <Banner />
            {/* <MarketSlider /> */}
            
            <div className="ticker-container">
                <BinanceTicker 
                    requestedBases={["BTC", "ETH", "LTC", "ADA", "AVAX", "SOL", "DOGE", "WIFF", "VINE", "DOGW"]} 
                    speedSeconds={60}
                    direction="left"
                />
                <BinanceTicker 
                    requestedBases={["BTT", "TRX", "XRP", "BNB", "USDT", "SHIB", "USDC", "LINK", "USDS", "XMR"]} 
                    speedSeconds={60}
                    direction="right"
                    offset={true}
                />
            </div>
            
            {/* <div className="container token-container">
                <TokenCard />
            </div> */}
            <BorderCount />
            <div className="container">
                <div className='grid'>
                    <div><PairTable /></div>
                    <div><News isHomepage={true} /></div>
                </div>
            </div>

            {/* <StepByStep /> */}
            <CollaborationSection />

            <Cta1
                title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}
            />
        </div>
    )
}


